import { StyleSheet, Platform } from 'react-native';

const styles = StyleSheet.create({
  container: {
    flexGrow: 1,
  },
  subHeading: {
    textAlign: 'center',
    color: '#707070',
    marginBottom: 20,
    marginTop: 5,
    fontSize: 20,
  },
  logoWrapper: {
    marginTop: 20,
  },
  card: {
    backgroundColor: 'white',
    marginHorizontal: 10,
    marginTop: 20,
    borderRadius: 10,
    padding: 10,
    marginBottom: 40,
  },
  inputLeft: {
    flex: 0.5,
    borderRightWidth: 0,
    borderRightColor: '#ccc',
  },
  inputWrapper: {
    borderBottomWidth: 1,
    borderBottomColor: '#ccc',
    flexDirection: 'row',
    marginBottom: 12,
  },
  textInput: {
    paddingVertical: 5,
    paddingHorizontal: 10,
    fontSize: 15,
    color: '#707070',
  },
  checkboxContainerStyle: {
    backgroundColor: 'transparent',
    paddingVertical: 2,
    borderWidth: 0,
    marginBottom: 0,
    paddingRight: 0,
  },
  checkboxTextStyle: {
    color: '#707070',
    fontWeight: '400',
  },
  link: {
    color: '#3d5ed7',
    textDecorationLine: 'underline',
    marginTop: 5,
  },
  checkboxWrapper: {
    flexDirection: 'row',
    paddingLeft: 10,
  },
  termsContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    flex: 1,
  },
  termsContentContainer: {
    flexGrow: 1,
    paddingHorizontal: 15,
    paddingBottom: 20,
  },
  paragraph: {
    marginBottom: 15,
  },
  loaderContainer: {
    flex: 1,
    alignItems: 'center',
    paddingTop: 20,
  },
  overlay: {
    marginTop: 40,
    ...Platform.select({
      web: {
        maxWidth: 600,
        margin: 'auto',
      },
      default: {
        margin: 0,
      },
    }),
  },
  closeButtonContainer: {
    height: '100%',
    zIndex: 1000,
    flex: 1,
    alignContent: 'center',
    alignItems: 'flex-start',
    justifyContent: 'center',
    marginStart: 10,
    marginTop: 10,
  },
  topOverlay: {
    flex: 1,
    position: 'absolute',
    opacity: 0.5,
    borderTopStartRadius: 10,
    borderTopEndRadius: 10,
    overflow: 'hidden',
    right: 0,
    top: 0,
    width: '100%',
    height: 40,
    fontWeight: 'bold',
    zIndex: 1001,
    backgroundColor: '#ffffff',
    padding: 0,
    marginTop: 0,
  },
  scrollView: {
    backgroundColor: '#ffffff',
    marginHorizontal: 0,
    borderRadius: 10,
    minHeight: '100%',
    paddingTop: 50,
    paddingHorizontal: 20,
  },
  loadingIndicator: {
    marginTop: 20,
  },
  modalIcon: {
    borderWidth: 1,
    borderRadius: 40,
    borderColor: '#cccccc',
    padding: 12,
    marginBottom: 16,
    alignSelf: 'center',
    color: '#505050',
    opacity: 0.5,
  },
  iconBase: {
    width: 24,
    height: 24,
  },
  htmlContent: {
    marginBottom: 100,
  },
  title: {
    position: 'absolute',
    textAlign: 'center',
    alignSelf: 'center',
    color: '#000000',
    fontSize: 18,
    zIndex: 1001,
  },
});

export default styles;
